import Accordion from "../Accordion"
import * as S from "./style"

export default function Footer() {
    return (
        <S.Container>
         <img src="images/perguntas.svg" alt="" />
             <Accordion
                title={"Como vou receber o produto?"}
                content={'O acesso ao produto é imediato após a confirmação do seu pagamento. É enviado o seu acesso ao seu e-mail e WhatsApp, você faz o download do conteúdo no seu celular e pronto!'}
             />
             <Accordion
                title={"Terei acesso ao conteúdo por quanto tempo?"}
                content={'Você terá acesso vitalício, a partir do momento em que você o adquire, você terá o livro para desfrutar as suas lições pelo resto da sua vida.'}
             />
        </S.Container>
    )
}